var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9208F044-FAA1-4304-8FB8-768AE3EB07E7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BBFD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8CDFE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-Requirement-Popup",
    transform: "translate(-520.000000, -520.000000)",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Popup",
    transform: "translate(208.000000, 196.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Link-(Affiliate)",
    transform: "translate(292.000000, 304.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Link-Icon",
    transform: "translate(20.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5371652,15.4630524 C25.1379068,16.0639228 25.1378025,17.0380218 24.5369322,17.6387635 C23.9360618,18.2395051 22.9619628,18.2394008 22.3612211,17.6385304 C19.4256315,14.7023119 14.6469305,14.6489261 11.6436021,17.4784833 L11.4786,17.6386469 L5.31949176,23.7977551 C2.32939615,26.7884913 2.32939615,31.689861 5.31937526,34.6798401 C8.25570822,37.6161731 13.0344227,37.6695609 16.0371451,34.8400037 L16.2021129,34.6798401 L20.0044169,30.8775361 C20.6052229,30.2767301 21.5793219,30.2767301 22.1801279,30.8775361 C22.7493126,31.4467208 22.7792697,32.3509385 22.2699992,32.9553898 L22.1801279,33.0532472 L18.3779405,36.8554346 C14.1863615,41.0479115 7.33602459,41.0479115 3.14366422,36.8555511 C-0.983402654,32.7284843 -1.04689599,26.0247322 2.95318421,21.8175256 L3.14366422,21.6221606 L9.30288894,15.4629359 C13.4952493,11.2705755 20.3455862,11.2705755 24.5371652,15.4630524 Z M36.8563443,3.14425571 C40.9834111,7.27132259 41.0469045,13.9750747 37.0467594,18.1823461 L36.8562763,18.3777141 L30.6963503,24.5368709 C26.5047786,28.7284427 19.6545315,28.7284427 15.4629598,24.5368709 C14.8621538,23.9360649 14.8621538,22.9619659 15.4629598,22.3611599 C16.0637658,21.7603539 17.0378648,21.7603539 17.6386708,22.3611599 C20.5742676,25.2967567 25.3530554,25.3501312 28.3557416,22.5212191 L28.5207072,22.361092 L34.6805167,16.2020517 C37.6706123,13.2113155 37.6706123,8.30994585 34.6806332,5.31996674 C31.7443003,2.38363378 26.9655858,2.33024591 23.9628633,5.15980313 L23.7978956,5.31996674 L19.9955916,9.1222707 C19.3947856,9.72307671 18.4206866,9.72307671 17.8198806,9.1222707 C17.2506959,8.55308606 17.2207388,7.64886836 17.7300093,7.04441708 L17.8198806,6.94655966 L21.622068,3.14437223 C25.813647,-1.04810466 32.6639839,-1.04810466 36.8563443,3.14425571 Z",
    id: "Combined-Shape-Copy-3"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.6a68a108.svg";
export { ForwardRef as ReactComponent };